import { render, staticRenderFns } from "./FormularyForm.vue?vue&type=template&id=4ec6ac7a&scoped=true&"
import script from "./FormularyForm.vue?vue&type=script&lang=js&"
export * from "./FormularyForm.vue?vue&type=script&lang=js&"
import style0 from "./FormularyForm.vue?vue&type=style&index=0&id=4ec6ac7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6ac7a",
  null
  
)

export default component.exports